import { useState } from 'react';
import { Code2, KeyRound, BookOpen, FlaskConical } from 'lucide-react';
import { ApiKeysPanel } from '../components/api/ApiKeysPanel';
import { ApiDocsPanel } from '../components/api/ApiDocsPanel';
import { ApiTesterPanel } from '../components/api/ApiTesterPanel';

const tabs = [
  { id: 'keys', label: 'API Keys', icon: KeyRound },
  { id: 'docs', label: 'Documentacion', icon: BookOpen },
  { id: 'test', label: 'Probar envio', icon: FlaskConical },
];

export default function ApiDocs() {
  const [tab, setTab] = useState('keys');
  const [apiKey, setApiKey] = useState('');

  return (
    <div className="space-y-6 max-w-6xl" data-testid="api-page">
      <div>
        <h1 className="text-2xl font-bold text-white flex items-center gap-2"><Code2 className="w-6 h-6 text-cyan-400" /> API para desarrolladores</h1>
        <p className="text-sm text-zinc-400 mt-1">Envia RCS/SMS desde tu CRM, tienda o automatizaciones (n8n, Make, Zapier) con la API REST v1. Webhooks al cambiar el estado de cada mensaje.</p>
      </div>

      <div className="flex gap-1 border-b border-white/5" data-testid="api-tabs">
        {tabs.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            data-testid={`api-tab-${t.id}`}
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === t.id ? 'border-cyan-400 text-cyan-300' : 'border-transparent text-zinc-500 hover:text-zinc-200'}`}
          >
            <t.icon className="w-4 h-4" /> {t.label}
          </button>
        ))}
      </div>

      {tab === 'keys' && <ApiKeysPanel onKeyCreated={(k) => setApiKey(k)} />}
      {tab === 'docs' && <ApiDocsPanel />}
      {tab === 'test' && <ApiTesterPanel apiKey={apiKey} setApiKey={setApiKey} />}
    </div>
  );
}
